export interface EmployeeFundRecord {
  id: number;
  amount: number;
  dateTime: string;
  changeType: string;
  notes: string;
  relatedTransactionId?: number;
  relatedFundTransferId?: number;
  balanceBefore: number;
  balanceAfter: number;
}

export interface EmployeeFundRecordResponse {
  content: EmployeeFundRecord[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export const CHANGE_TYPE_LABELS: Record<string, string> = {
  company_transfer_in: 'Nhận từ công ty',
  company_transfer_out: 'Chuyển về công ty',
  company_transfer_adjustment: 'Sửa chuyển về công ty',
  company_transfer_cancel: 'Hủy chuyển về công ty',
  maturity_transaction: 'Giao dịch đáo hạn',
  revert_transaction: 'Hoàn tác giao dịch',
  maturity_payment: 'Thanh toán kỳ đáo hạn',
  withdrawal_service: 'Giao dịch rút tiền',
  withdrawal_pos_receive: 'Nhận tiền từ POS',
  withdrawal_pos_revert: 'Hoàn tác nhận tiền từ POS',
  cash_back_for_customer: 'Hoàn tiền cho khách hàng',
  cash_back_from_customer: 'Hoàn tiền từ khách hàng',
  adjustment: 'Điều chỉnh',
  reset: 'Reset số dư',
};

export const CHANGE_TYPE_COLORS: Record<string, string> = {
  company_transfer_in: 'green',
  company_transfer_out: 'red',
  company_transfer_adjustment: 'orange',
  company_transfer_cancel: 'green',
  maturity_transaction: 'blue',
  revert_transaction: 'gray',
  maturity_payment: 'blue',
  withdrawal_service: 'blue',
  withdrawal_pos_receive: 'green',
  withdrawal_pos_revert: 'red',
  cash_back_for_customer: 'red',
  cash_back_from_customer: 'green',
  adjustment: 'orange',
  reset: 'volcano',
};
